/**
 * @module cercaliagl/Notification
 */

import VNotification from './view/VNotification';

/**
 * @type {Object.<string, string>}
 * @api
 */
export const Severity = {
  /**
   * @api
   */
  INFO: 'info',
  /**
   * @api
   */
  WARNING: 'warning',
  /**
   * @api
   */
  ERROR: 'error',
};

/**
 * @classdesc
 * Create a styled notification with a message, severity and a duration.<br/>
 * @api
 */
class Notification {
  /**
   * @param {string} message Message.
   * @param {string=} [severity] Severity.
   * <ul>
   *  <li><b>cercaliagl.Notification.Severity.INFO</b>: Info severity, value: <code>info</code></li>
   *  <li><b>cercaliagl.Notification.Severity.WARNING</b>: Warning severity, value: <code>warning</code></li>
   *  <li><b>cercaliagl.Notification.Severity.INFO</b>: Error severity, value: <code>error</code></li>
   * </ul>
   * @param {number=} duration Duration.
   */
  constructor(message, severity = Severity.INFO, duration = 5000) {
    /**
     * @private
     * @type {VNotification}
     */
    this.vNotification_ = new VNotification(message, severity);

    /**
     * @private
     * @type {Element}
     */
    this.element_ = this.vNotification_.getElement();

    /**
     * @private
     * @type {string}
     */
    this.message_ = message;

    /**
     * @private
     * @type {string}
     */
    this.severity_ = severity;

    /**
     * @private
     * @type {number}
     */
    this.duration_ = duration;

    this.element_.setAttribute('severity', this.severity_);
    this.element_.setAttribute('message', this.message_);
    this.element_.setAttribute('duration', `${this.duration_}`);
  }

  /**
   * Display notification on map.
   * @param {Map|Element} mapOrElement Map or HTML Element
   * @api
   */
  display(mapOrElement) {
    let container;
    if (mapOrElement instanceof Element) {
      container = mapOrElement;
    } else {
      const mbMap = mapOrElement.getMapboxglMap();
      container = mbMap.getCanvas().parentElement;
    }
    this.vNotification_.appendTo(container);

    setTimeout(() => {
      container.removeChild(this.element_);
    }, this.duration_);
  }

  /**
   * Get HTML element.
   * @return {Element} HTML Element
   * @api
   */
  getElement() {
    return this.element_;
  }
}

export default Notification;
